import { render, staticRenderFns } from "./prizeLists.vue?vue&type=template&id=0ed81ce4&scoped=true&"
import script from "./prizeLists.vue?vue&type=script&lang=js&"
export * from "./prizeLists.vue?vue&type=script&lang=js&"
import style0 from "./prizeLists.vue?vue&type=style&index=0&id=0ed81ce4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed81ce4",
  null
  
)

export default component.exports